/** Width of the first dashboard column (Active discounts / News stack). */
export const cmpHomeDashboardNarrowColumnWidth = 446;

/** Active discounts and News panel outer padding. */
export const cmpHomeDashboardUniformPanelPadding = {
  px: [20, 20, 28],
  pt: [20, 20, 28],
  pb: [20, 20, 28]
};

/** Default padding for other CMP home dashboard panels. */
export const cmpHomeDashboardPanelPadding = {
  px: [20, 20, 28],
  pt: [20, 20, 28],
  pb: [24, 24, 40]
};

/** Panel header title typography (overrides learning hub dashboard title on desktop). */
export const cmpHomeDashboardPanelTitleProps = {
  fontSize: [24, 24, 28]
};

/** Max rows on Results to view and Latest orders dashboard panels. */
export const cmpHomeDashboardListPageSize = 5;

/** Scrollable list body under panel title (fits ~5 rows, then scrolls). */
export const cmpHomeDashboardScrollableListBoxProps = {
  width: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  maxHeight: [380, 380, 420],
  style: { WebkitOverflowScrolling: "touch" }
};

/** Max promos on the CMP home News panel. */
export const cmpHomeDashboardNewsPromoLimit = 10;

/** Scrollable News promo list (height capped by column flex layout on desktop). */
export const cmpHomeDashboardScrollableNewsListBoxProps = {
  width: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  style: { WebkitOverflowScrolling: "touch" }
};

/** Gap between CMP home dashboard columns and stacked panels. */
export const cmpHomeDashboardGridGap = 16;

/** Icon placeholder / top section background (Patients & Orders panels). */
export const cmpHomeDashboardSectionLeadingBg = "#cbe1da";

/** Mint highlight on first row (Order tests / View patients). */
export const cmpHomeDashboardTopSectionBorderRadius = 12;

/** Patients / Orders panel section rows (matches learning hub list labels). */
export const cmpHomeDashboardSectionTitle = {
  fontFamily: "gilroyBold",
  fontSize: [16, 16, 18],
  lineHeight: ["24px", "24px", "28px"]
};

export const cmpHomeDashboardSectionDescription = {
  fontFamily: "gilroyMedium",
  fontSize: [14, 14, 14],
  lineHeight: ["20px", "20px", "20px"]
};

/** Primary line in results / list rows (patient name, etc.). */
export const cmpHomeDashboardListPrimary = {
  fontFamily: "gilroyBold",
  fontSize: [16, 16, 18],
  lineHeight: ["24px", "24px", "28px"]
};

/** Secondary line in results / list rows. */
export const cmpHomeDashboardListSecondary = {
  fontFamily: "gilroyMedium",
  fontSize: [14, 14, 14],
  lineHeight: ["20px", "20px", "20px"]
};

/** Latest orders date row (fixed 16px). */
export const cmpHomeDashboardOrderMetaBold = {
  fontFamily: "gilroyBold",
  fontSize: 16,
  lineHeight: "20px"
};

export const cmpHomeDashboardOrderMetaLink = {
  fontFamily: "gilroyMedium",
  fontSize: 16,
  lineHeight: "20px"
};

export const cmpHomeDashboardEmptyMessage = {
  fontFamily: "gilroyMedium",
  fontSize: [14, 14, 14],
  lineHeight: ["20px", "20px", "20px"]
};

/** Mobile py 20 (New results list); desktop py 16. */
export const cmpHomeDashboardListRowPy = [20, 20, 16];

export const cmpHomeDashboardSectionRowGap = 16;
export const cmpHomeDashboardListInnerStackGap = 4;
export const cmpHomeDashboardOrderDateOrderGap = 20;

/** Full-bleed section link inset (Patients / Orders). */
export const cmpHomeDashboardSectionPadding = "16px";

/** White inset around Latest orders balance footer (aligns with panel header / list). */
export const cmpHomeDashboardBalanceFooterOuterPadding = {
  px: cmpHomeDashboardPanelPadding.px,
  pb: cmpHomeDashboardPanelPadding.pb
};

/** Grey balance bar padding inside the white inset. */
export const cmpHomeDashboardBalanceFooterInnerPadding = {
  py: 2,
  px: 3
};

export const cmpHomeDashboardBalanceFooterBorderRadius = "12px";
